// extracted by mini-css-extract-plugin
module.exports = {"defaultInput":"Form_defaultInput__2aRch","button":"Form_button__2Uog-","buttonWrapper":"Form_buttonWrapper__1HYvH"};